import { render, staticRenderFns } from "./ManagementMsTeams.vue?vue&type=template&id=f5907814&"
import script from "./ManagementMsTeams.vue?vue&type=script&lang=js&"
export * from "./ManagementMsTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports